import React from 'react';
import { Row, Col } from 'antd';
import styles from './styles.module.less';
import dayjs from 'dayjs';

const Horoscope = ({ profiles }) => {
  const profileData =
    Array.isArray(profiles) && profiles.length > 0
      ? profiles[0]
      : profiles || {};

  // console.log('profileData', profileData?.ProfileHoroscopes?.[0]?.dob);
  const dob = profileData?.ProfileHoroscopes?.[0]?.dob;
  const formattedDOB = dob
    ? dayjs(dob, 'DD-MM-YYYY').format('DD MMM YYYY')
    : 'Not provided';

  // const dateOnly = dob
  //   ? new Date(dob).toLocaleDateString('en-GB', {
  //       day: '2-digit',
  //       month: 'short',
  //       year: 'numeric'
  //     })
  //   : 'N/A';

  const timeOfBirth =
    profileData?.ProfileHoroscopes?.[0]?.dob_time || 'Not provided';
  // const formattedTimeOfBirth = timeOfBirth
  //   ? new Date(timeOfBirth)
  //       .toLocaleTimeString('en-US', {
  //         hour: 'numeric',
  //         minute: '2-digit',
  //         hour12: true
  //       })
  //       .replace(':', '.')
  //   : 'N/A';
  const placeOfBirth = profileData?.ProfileHoroscopes?.[0]
    ? `${profileData.ProfileHoroscopes[0]?.home_town_details}, ${profileData.ProfileHoroscopes[0]?.City?.city}, ${profileData.ProfileHoroscopes[0]?.State?.state}, ${profileData.ProfileHoroscopes[0]?.Country?.country}`
    : 'Not provided';

  // console.log('formattedTime', placeOfBirth);

  // const starSign =
  //   profileData?.ProfileHoroscopes?.[0]?.StarSign?.star_sign || 'N/A';
  // const Rasi = profileData?.ProfileHoroscopes?.[0]?.Rashi?.zodiac_sign || 'N/A';
  // Get horoscope match preference or use default
  // const horoscopeMatch =
  //   profileData?.ProfileHoroscopes?.[0]?.horoscope_match || 'N/A';
  const horoscopeMatch = (() => {
    const match = profileData?.ProfileHoroscopes?.[0]?.horoscope_match;
    if (match === 'notNecessary') return 'Not Necessary';
    if (match === 'preferable') return 'Preferable';
    if (match === 'important') return 'Important';
    return match || 'Not provided';
  })();

  return (
    <>
      <div className={styles.horoscopestyles}>
        <Row className={styles.horo}>
          <Col className={styles.colStyle}>
            <span className={styles.birth}>Date of Birth</span>
            <span className={styles.birth1}> {formattedDOB} </span>
          </Col>
          <Col className={styles.colStyle}>
            <span className={styles.birth}>Time of Birth</span>
            <span className={styles.birth1}> {timeOfBirth} </span>
          </Col>
          <Col className={styles.colStyle}>
            <span className={styles.birth}>Place of Birth</span>
            <span className={styles.birth1}> {placeOfBirth} </span>
          </Col>
        </Row>
        <Row className={styles.horo}>
          {/* <Col className={styles.colStyle}>
            <span className={styles.star}>Star Sign</span>
            <span className={styles.star1}> {starSign} </span>
          </Col>
          <Col className={styles.colStyle}>
            <span className={styles.star}>Rasi</span>
            <span className={styles.star1}> {Rasi} </span>
          </Col> */}
          <Col className={styles.colStyle}>
            <span className={styles.star}>Horoscope Match</span>
            <span className={styles.star1}> {horoscopeMatch} </span>
          </Col>
        </Row>
      </div>
    </>
  );
};

export default Horoscope;
